import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import ListDataProvider from '../../toolkit/mobx-connectors/ListDataProvider';
import DataTable from '../../toolkit/DataTable/DataTable';
import axios from '../../utils/axios';
import Filter from '../../utils/filter';
import createParams from '../../utils/filter-params';
import snackbarStore from '../../stores/snackbar-store';
import config from './DatasetsConfig';

const styles = theme => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  button: {
    margin: 0,
    textDecoration: 'none',
    marginLeft: theme.spacing(1)
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },
  tableCellAction: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  tableCell: {},
  tableCellButton: {}
});

const Datos = props => {
  const { classes, tipoDeServicioId } = props;
  const configuraciones = config({ classes });
  const { dataset } = props.match.params;
  const { datosConfig, datosSettings } = configuraciones[dataset];

  const getSettings = () => {
    return datosSettings;
  };

  const onReloadTable = () => {
    const settings = getSettings();
    const params = createParams({ ...props.datos.list, settings });

    if (params.filter) {
      params.filter.and(
        Filter.path('empresaActividades.actividad.tipoListado').like('REPSE')
      );
    } else {
      params.filter = Filter.path(
        'empresaActividades.actividad.tipoListado'
      ).like('REPSE');
    }
    params.filter.and(
      Filter.path('empresaActividades.actividad.tipoServicio.id').eq(
        `${tipoDeServicioId}`
      )
    );
    params.filter.and(Filter.path('registros.tiporegistro.id').eq(48));
    params.filter.and(
      Filter.path('empresaActividades.actividad.tipoServicio.id').notEq(999999)
    );
    params.filter = JSON.stringify(params.filter);
    axios
      .get('empresa', {
        data: {},
        params
      })
      .then(resp => {
        props.datos.list.dataLoaded(resp.data.data, {
          currentPage: resp.data.meta.currentPage - 1,
          pageSize: resp.data.meta.pageSize,
          itemsCount: resp.data.meta.total
        });
      })
      .catch(() => {
        snackbarStore.openSnackbar('Error al obtener los datos', 'error');
      });
  };

  const filterExists = (filters, match) => {
    let exists = false;
    filters.forEach(item => {
      if (item.key === match) {
        exists = true;
      }
    });
    return exists;
  };

  const onDataDownload = () => {
    const settings = getSettings();
    const params = createParams({ ...props.datos.list, settings });
    // TODO sobreecribir pagesize y demas para que traiga todo
    params.page = 'all';
    params.pageSize = props.datos.list.pagingData.itemsCount;
    // params.pageSize= 10;
    const filters = props.datos.list.queryData.querys;
    const promise = axios.get(datosConfig.servicio, {
      data: {},
      params
    });

    if (filterExists(filters, 'empresa.ruc')) {
      return promise;
    }
    if (filterExists(filters, 'empresa.razonsocial')) {
      return promise;
    }
    if (!filters || filters.length < 2) {
      snackbarStore.openSnackbar(
        'Debe aplicar al menos dos filtros',
        'warning'
      );
      return null;
    }
    return promise;
  };

  return (
    <React.Fragment>
      <div className={classes.layout}>
        <ListDataProvider
          listStore={props.datos.list}
          render={listProps => (
            <MyDataTableTranslated
              title={datosConfig.titulo}
              settings={getSettings()}
              onReloadTable={() => onReloadTable()}
              onDataDownload={() => onDataDownload()}
              // defaultFilters={defaultFilters}
              fileName={datosConfig.servicio}
              {...listProps}
            />
          )}
        />
      </div>
    </React.Fragment>
  );
};

const MyDataTableTranslated = props => {
  const { t } = useTranslation();
  const { title, settings, ...remaining } = props;
  // eslint-disable-next-line guard-for-in
  for( const key in settings){
    settings[key].label = t(settings[key].label);
  }
  
  return <DataTable {...remaining} title={t(title)} settings={settings}/>;
};

Datos.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(inject('datos')(observer(Datos)));